export const notes = [
  {
    noteTitle: 'Contact Search',
    note: 'Ability to search contact data',
  },
];
